'use strict';

module.exports = {
    trains: /*@ngInject*/  ["TrainService", "ProjectService", function (TrainService, ProjectService) {
        return TrainService.getTrains().query({"projectId": ProjectService.getSelectedProjectId()}).$promise;
    }]
};